import {
  GET_USER_REQ,
  GET_USER_SUCCESS,
  GET_USER_ERROR,
  CREATE_USER_REQ,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  GET_USER_DETAIL_REQ,
  GET_USER_DETAIL_SUCCESS,
  GET_USER_DETAIL_ERROR,
  GET_COMPANY_DETAIL_REQ,
  GET_COMPANY_DETAIL_SUCCESS,
  GET_COMPANY_DETAIL_ERROR,
  GET_LOCATION_REQ,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_ERROR,
  GET_CARD_REQ,
  GET_CARD_SUCCESS,
  GET_CARD_ERROR,
  CREATE_LOCATION_REQ,
  CREATE_LOCATION_SUCCESS,
  CREATE_LOCATION_ERROR,
  DELETE_LOCATION_REQ,
  DELETE_LOCATION_SUCCESS,
  DELETE_LOCATION_ERROR,
  UPDATE_LOCATION_REQ,
  UPDATE_LOCATION_SUCCESS,
  UPDATE_LOCATION_ERROR,
  UPDATE_ASSETS_REQ,
  UPDATE_ASSETS_SUCCESS,
  UPDATE_ASSETS_ERROR,
  UPDATE_BUSINESS_INFO_REQ,
  UPDATE_BUSINESS_INFO_SUCCESS,
  UPDATE_BUSINESS_INFO_ERROR,
  UPDATE_PROFILE_INFO_REQ,
  UPDATE_PROFILE_INFO_SUCCESS,
  UPDATE_PROFILE_INFO_ERROR,
  CREATE_ASSETS_REQ,
  CREATE_ASSETS_SUCCESS,
  CREATE_ASSETS_ERROR,
  DELETE_CARD_REQ,
  DELETE_CARD_SUCCESS,
  DELETE_CARD_ERROR,
  SET_CARD_DEFAULT_REQ,
  SET_CARD_DEFAULT_SUCCESS,
  SET_CARD_DEFAULT_ERROR,
  GET_ZIP_CODE_REQ,
  GET_ZIP_CODE_SUCCESS,
  GET_ZIP_CODE_ERROR,
  VERIFY_ZIP_CODE_REQ,
  VERIFY_ZIP_CODE_SUCCESS,
  VERIFY_ZIP_CODE_ERROR,
  GET_USER_PLANTOWNER_REQ,
  GET_USER_PLANTOWNER_SUCCESS,
  GET_USER_PLANTOWNER_ERROR,
  GET_USER_PLATFROM_OWNER_SUCCESS,
  GET_USER_PLATFROM_OWNER_ERROR,
  GET_USER_PLATFROM_OWNER_REQ,
  UPDATE_PLATFORM_USER_REQ,
  UPDATE_PLATFORM_USER_SUCCESS,
  UPDATE_PLATFORM_USER_ERROR,
  UPDATE_PLATFORM_REQ,
  UPDATE_PLATFORM_SUCCESS,
  UPDATE_PLATFORM_ERROR,
} from "../constants";

export default class UserAction {
  static getUserReq(id, params) {
    return {
      type: GET_USER_REQ,
      id,
      params,
    };
  }
  static getUserSuccess(res, id, metaData) {
    return {
      type: GET_USER_SUCCESS,
      res,
      id,
      metaData,
    };
  }
  static getUserError(e) {
    return {
      type: GET_USER_ERROR,
      e,
    };
  }
  static createUserReq(payload, cb, params) {
    return {
      type: CREATE_USER_REQ,
      payload,
      cb,
      params,
    };
  }
  static createUserSuccess(res) {
    return {
      type: CREATE_USER_SUCCESS,
      res,
    };
  }
  static createUserError(e) {
    return {
      type: CREATE_USER_ERROR,
      e,
    };
  }

  static getUserDetailReq(userId, cb) {
    return {
      type: GET_USER_DETAIL_REQ,
      userId,
      cb,
    };
  }
  static getUserDetailSuccess(res) {
    return {
      type: GET_USER_DETAIL_SUCCESS,
      res,
    };
  }
  static getUserDetailError(e) {
    return {
      type: GET_USER_DETAIL_ERROR,
      e,
    };
  }

  static getUserPlatfromOwnerReq(platformuserId, cb) {
    return {
      type: GET_USER_PLATFROM_OWNER_REQ,
      platformuserId,
      cb,
    };
  }
  static getUserPlatfromOwnerSuccess(res) {
    return {
      type: GET_USER_PLATFROM_OWNER_SUCCESS,
      res,
    };
  }
  static getUserPlatfromOwnerError(e) {
    return {
      type: GET_USER_PLATFROM_OWNER_ERROR,
      e,
    };
  }

  static updateUserPlatfromOwnerReq(id, payload, cb) {
    return {
      type: UPDATE_PLATFORM_USER_REQ,
      id,
      payload,
      cb,
    };
  }
  static updateUserPlatfromOwnerSuccess(res) {
    return {
      type: UPDATE_PLATFORM_USER_SUCCESS,
      res,
    };
  }
  static updateUserPlatfromOwnerError(e) {
    return {
      type: UPDATE_PLATFORM_USER_ERROR,
      e,
    };
  }

  static updatePlatfromOwnerReq(payload, cb) {
    return {
      type: UPDATE_PLATFORM_REQ,
      payload,
      cb,
    };
  }
  static updatePlatfromOwnerSuccess(res) {
    return {
      type: UPDATE_PLATFORM_SUCCESS,
      res,
    };
  }
  static updatePlatfromOwnerError(e) {
    return {
      type: UPDATE_PLATFORM_ERROR,
      e,
    };
  }

  static getCompantDetailReq() {
    return {
      type: GET_COMPANY_DETAIL_REQ,
    };
  }
  static getCompanyDetailSuccess(res) {
    return {
      type: GET_COMPANY_DETAIL_SUCCESS,
      res,
    };
  }
  static getCompanyDetailError(e) {
    return {
      type: GET_COMPANY_DETAIL_ERROR,
      e,
    };
  }
  static getLocationReq() {
    return {
      type: GET_LOCATION_REQ,
    };
  }
  static getLocationSuccess(res) {
    return {
      type: GET_LOCATION_SUCCESS,
      res,
    };
  }
  static getLocationError(e) {
    return {
      type: GET_LOCATION_ERROR,
      e,
    };
  }
  static getCardsReq(params) {
    return {
      type: GET_CARD_REQ,
      params,
    };
  }
  static getCardsSuccess(res) {
    return {
      type: GET_CARD_SUCCESS,
      res,
    };
  }
  static getCardsError(e) {
    return {
      type: GET_CARD_ERROR,
      e,
    };
  }
  static createLocationReq(payload, cb) {
    return {
      type: CREATE_LOCATION_REQ,
      payload,
      cb,
    };
  }
  static createLocationSuccess(res) {
    return {
      type: CREATE_LOCATION_SUCCESS,
      res,
    };
  }
  static createLocationError(e) {
    return {
      type: CREATE_LOCATION_ERROR,
      e,
    };
  }
  static deleteLocationReq(id, cb) {
    return {
      type: DELETE_LOCATION_REQ,
      id,
      cb,
    };
  }
  static deleteLocationSuccess(res) {
    return {
      type: DELETE_LOCATION_SUCCESS,
      res,
    };
  }
  static deleteLocationError(e) {
    return {
      type: DELETE_LOCATION_ERROR,
      e,
    };
  }

  static UpdateLocationReq(body, id, cb) {
    return {
      type: UPDATE_LOCATION_REQ,
      body,
      id,
      cb,
    };
  }
  static UpdateLocationSuccess(id, data) {
    return {
      type: UPDATE_LOCATION_SUCCESS,
      id,
      data,
    };
  }
  static UpdateLocationError(e) {
    return {
      type: UPDATE_LOCATION_ERROR,
      e,
    };
  }

  static updateAssetsReq(id, body, cb) {
    return {
      type: UPDATE_ASSETS_REQ,
      body,
      id,
      cb,
    };
  }
  static updateAssetsSuccess(id, data) {
    return {
      type: UPDATE_ASSETS_SUCCESS,
      id,
      data,
    };
  }
  static updateAssetsError(e) {
    return {
      type: UPDATE_ASSETS_ERROR,
      e,
    };
  }

  static updateBusinessInfoReq(body, cb) {
    return {
      type: UPDATE_BUSINESS_INFO_REQ,
      body,
      cb,
    };
  }
  static updateBusinessInfoSuccess(id, data) {
    return {
      type: UPDATE_BUSINESS_INFO_SUCCESS,
      id,
      data,
    };
  }
  static updateBusinessInfoError(e) {
    return {
      type: UPDATE_BUSINESS_INFO_ERROR,
      e,
    };
  }

  static updateProfileInfoReq(body, cb, id, active) {
    return {
      type: UPDATE_PROFILE_INFO_REQ,
      body,
      cb,
      id,
      active,
    };
  }
  static updateProfileInfoSuccess(id, data) {
    return {
      type: UPDATE_PROFILE_INFO_SUCCESS,
      id,
      data,
    };
  }
  static updateProfileInfoError(e) {
    return {
      type: UPDATE_PROFILE_INFO_ERROR,
      e,
    };
  }

  static createAssetsReq(body, cb, id, active) {
    return {
      type: CREATE_ASSETS_REQ,
      body,
      cb,
      id,
      active,
    };
  }
  static createAssetsSuccess(id, data) {
    return {
      type: CREATE_ASSETS_SUCCESS,
      id,
      data,
    };
  }
  static createAssetsError(e) {
    return {
      type: CREATE_ASSETS_ERROR,
      e,
    };
  }

  static deleteCardReq(cardId, cb, id, active) {
    return {
      type: DELETE_CARD_REQ,
      cardId,
      cb,

      id,
    };
  }
  static deleteCardSuccess(id, data) {
    return {
      type: DELETE_CARD_SUCCESS,
      id,
      data,
    };
  }
  static deleteCardError(e) {
    return {
      type: DELETE_CARD_ERROR,
      e,
    };
  }

  static setCardDefaultReq(cardId, cb, id, active) {
    return {
      type: SET_CARD_DEFAULT_REQ,
      cardId,
      cb,
    };
  }
  static setCardDefaultSuccess(id, data) {
    return {
      type: SET_CARD_DEFAULT_SUCCESS,
      id,
      data,
    };
  }
  static setCardDefaultError(e) {
    return {
      type: SET_CARD_DEFAULT_ERROR,
      e,
    };
  }

  static verify_zipcode_req(payload, cb) {
    return {
      type: VERIFY_ZIP_CODE_REQ,
      payload,
      cb,
    };
  }
  static verify_zipcode_success(data) {
    return {
      type: VERIFY_ZIP_CODE_SUCCESS,
      data,
    };
  }
  static verify_zipcode_error(e) {
    return {
      type: VERIFY_ZIP_CODE_ERROR,
      e,
    };
  }
}
